export default __webpack_public_path__ + "static/media/gallery-wip-emitter_05.8c32be16.jpg";